import React, { useEffect, useState } from 'react';
import {
  useMediaQuery,
  Typography,
  Box,
  Button,
} from '@mui/material';
import CardPlanCode from './CardPlanCode';

export default function Step1({ onContinue, onOptionChange, month1, month2 }) {
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const [selectedOption, setSelectedOption] = useState(2);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const handleSelectOption = (option) => {
    setSelectedOption(option);
    let selectedData = option === 1 ? month1 : month2;
    onOptionChange(option, selectedData);
  };

  useEffect(() => {
    onOptionChange(2, month2);
  }, []);

  useEffect(() => {
    if (month1 && month2) {
      setIsDataLoaded(true);
    }
  }, [month1, month2]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: { xxs: '20px', sm: '0px' },
      }}
    >
      <Typography
        sx={{
          color: '#232B35',
          textAlign: 'center',
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 800,
          lineHeight: '24px',
          letterSpacing: '-0.43px',
          marginTop: '50px',
          marginBottom: '0px',
        }}
      >
        Unlock a World of New Opportunities on AdvisoryCloud{' '}
      </Typography>
      <Typography
        sx={{
          color: '#232B35',
          textAlign: 'center',
          fontSize: '14x',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '-0.43px',
          marginBottom: '10px',
        }}
      >
        Please select a plan type to gain full access:
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xxs: 'column', xs: 'row' },
          justifyContent: { xxs: 'center', sm: 'space-between' },
          flexWrap: 'wrap',
          marginBottom: '30px',
          gap: 2,
        }}
      >
        <CardPlanCode
          selected={selectedOption === 1}
          option={1}
          onClick={() => handleSelectOption(1)}
          plan={month1}
        />
        <CardPlanCode
          selected={selectedOption === 2}
          option={2}
          onClick={() => handleSelectOption(2)}
          plan={month2}
        />
      </Box>

      <Button
        disabled={!isDataLoaded}
        sx={{
          marginBottom: '20px',
          fontSize: '15px',
          borderRadius: '999px',
          fontWeight: 700,
          width: { xxs: '90%', xs: '168px' },
          height: '44px',
          backgroundColor: isDataLoaded ? '#3171F6' : '#bdbdbd',
          color: isDataLoaded ? '#FFFFFF' : '#666666',
          borderColor: 'none',
          fontFamily: 'Poppins',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          position: { xxs: 'sticky', xs: 'relative' },
          bottom: { xxs: '10px', xs: 'unset' },
          zIndex: { xxs: 1000, xs: 'unset' },
        }}
        onClick={onContinue}
        variant="contained"
      >
        Continue
      </Button>
    </Box>
  );
}
